import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'translations/en.json';
import it from 'translations/it.json';
import de from 'translations/de.json';
import fr from 'translations/fr.json';
import es from 'translations/es.json';

const resources = {
  en,
  it,
  de,
  fr,
  es
};

i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language || navigator.userLanguage,
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false
  }
});

export default i18n;
